import { render, staticRenderFns } from "./viewConfigBak.vue?vue&type=template&id=8260c28a&"
import script from "./viewConfigBak.vue?vue&type=script&lang=js&"
export * from "./viewConfigBak.vue?vue&type=script&lang=js&"
import style0 from "./viewConfigBak.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports